// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaDtacogoV1Output } from "./RanaDtacogoV1Output";
import {
  RanaDtacogoV1OutputFromJSON,
  RanaDtacogoV1OutputFromJSONTyped,
  RanaDtacogoV1OutputToJSON,
  RanaDtacogoV1OutputToJSONTyped,
} from "./RanaDtacogoV1Output";
import type { RanaDtacogoV1Input } from "./RanaDtacogoV1Input";
import {
  RanaDtacogoV1InputFromJSON,
  RanaDtacogoV1InputFromJSONTyped,
  RanaDtacogoV1InputToJSON,
  RanaDtacogoV1InputToJSONTyped,
} from "./RanaDtacogoV1Input";

/**
 *
 * @export
 * @interface RanaDtacogoV1Schema
 */
export interface RanaDtacogoV1Schema {
  /**
   *
   */
  tag: RanaDtacogoV1SchemaTagEnum;
  /**
   *
   */
  inputs: RanaDtacogoV1Input;
  /**
   *
   */
  outputs: RanaDtacogoV1Output;
}

/**
 * @export
 */
export const RanaDtacogoV1SchemaTagEnum = {
  RanaDtacogoV1: "rana-dtacogo-v1",
} as const;
export type RanaDtacogoV1SchemaTagEnum =
  (typeof RanaDtacogoV1SchemaTagEnum)[keyof typeof RanaDtacogoV1SchemaTagEnum];

/**
 * Check if a given object implements the RanaDtacogoV1Schema interface.
 */
export function instanceOfRanaDtacogoV1Schema(value: object): value is RanaDtacogoV1Schema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "rana-dtacogo-v1") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function RanaDtacogoV1SchemaFromJSON(json: any): RanaDtacogoV1Schema {
  return RanaDtacogoV1SchemaFromJSONTyped(json, false);
}

export function RanaDtacogoV1SchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RanaDtacogoV1Schema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: RanaDtacogoV1InputFromJSON(json["inputs"]),
    outputs: RanaDtacogoV1OutputFromJSON(json["outputs"]),
  };
}

export function RanaDtacogoV1SchemaToJSON(json: any): RanaDtacogoV1Schema {
  return RanaDtacogoV1SchemaToJSONTyped(json, false);
}

export function RanaDtacogoV1SchemaToJSONTyped(
  value?: RanaDtacogoV1Schema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: RanaDtacogoV1InputToJSON(value["inputs"]),
    outputs: RanaDtacogoV1OutputToJSON(value["outputs"]),
  };
}
